import {AfterViewInit, Component, Input, NgModule, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule, IonTextarea} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, FormControl} from '@angular/forms';
import {CardModule} from '../../card/card.module';
import {DialogModule} from '../../../../common/dialog/dialog.module';
import {RichTextEditorModule} from '../../../../../components/common/rich-text-editor/rich-text-editor.module';
import {IDialogComponent} from '../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../common/dialog/dialogWithInput';
import {RichTextEditorComponent} from '../../../../../components/common/rich-text-editor/rich-text-editor.component';
import {
  TranscriptionConfig
} from '../../../../common/audio/transcription/api/component/audio-transcription/audio-transcription.component';
import {
  AudioTranscriptionConfig
} from "../../../../common/audio/transcription/api/component/audio-transcription-v2/audio-transcription-v2.component";


export interface CommentDialogInput {
  comment: string;
  audioTranscriptionConfig: AudioTranscriptionConfig;
}

export interface CommentDialogResult {
  comment: string;
}

@Component({
  template: `
    <app-dialog [dialogWithInput]="dialog" (closeEvent)="close()" [manualCloseManagement]="true">
      <app-card>
        <app-rich-text-editor #editor focus="true" [parentFormGroup]="formGroup" parentFormControlName="comment" [audioTranscriptionConfig]="dialog.input.audioTranscriptionConfig"></app-rich-text-editor>
      </app-card>
    </app-dialog>
  `,
})
export class CommentMenuComponent implements IDialogComponent<CommentDialogInput, CommentDialogResult>,
    OnInit, AfterViewInit{
  dialog: DialogWithInput<CommentDialogInput, CommentDialogResult>;
  formGroup: FormGroup;

  @ViewChild('editor') editor: RichTextEditorComponent;
  constructor(private formBuilder: FormBuilder) {
    this.formGroup = this.formBuilder.group({
      comment: new FormControl(undefined)
    });
  }

  ngOnInit() {
    this.formGroup.patchValue({comment: this.dialog.input.comment});
  }

  ngAfterViewInit(): void {
  }

  close() {
    this.dialog.close({
      comment: this.formGroup.get('comment').value
    });
  }

  /* private focusTextArea() {
    this.textArea.getInputElement().then(inputElement => {
      let text:string = this.parentFormGroup.get(this.parentFormControlName).value;
      inputElement.focus();
      inputElement.setSelectionRange(text.length, text.length);
    });
  } */
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    CardModule,
    DialogModule,
    RichTextEditorModule,
  ],
  declarations: [
    CommentMenuComponent,
  ],
  exports: [
    CommentMenuComponent
  ],
})
export class CommentMenuModule{
}
